import React, { useEffect } from 'react';
import { getI18n } from 'react-i18next';
import logo from '../assets/branding/logo-rounded-1024.png';
import { IS_APP_BUILD } from '../lib/buildTarget';

// post-t7-2c (F2 y F3, Anexo D.1 y D.2): LA RED CONTRA LAS CAIDAS.
//
// ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos; los acentos van con escapes).
//
// Un limite de error de React montado en `App.js` alrededor de TODO el arbol (por fuera del proveedor de sesion), en
// la web y en la app. Si algo truena al pintar, en vez de la pantalla negra sale esta: el fondo de la casa, el logo
// chico (el mismo PNG de `BootSplash`), "Algo salio mal." y UN boton naranja de 44 de alto, sin spinner. El boton
// nunca deja de hacer algo:
//   1. "Reintentar": recarga la pagina entera (`window.location.reload()`).
//   2. Si la MISMA caida (mismo mensaje) vuelve en menos de 30 s: "Ir al inicio" (`/dashboard`).
//   3. Si cae otra vez: "Cerrar sesion", el `logout` de la casa (el que conserva la bodega de un registrado, #507).
// La cuenta vive en `sessionStorage` (envuelta en try/catch: sin ella, siempre "Reintentar").
//
// EL LOGOUT, Y POR QUE HAY UN PUENTE: la red va por FUERA de `AuthProvider` (si el proveedor truena, la red tambien
// lo atrapa), asi que no puede leer el contexto. `PuenteDeSalida` vive DENTRO del proveedor y le deja a la red el
// `logout` de la casa en cada pintado; cuando la red pinta, el arbol de abajo ya se desmonto, pero el `logout` que
// dejo sigue sirviendo: lo que hace (la frontera de la bodega, la revocacion, borrar los tokens) no depende de nada
// montado. Despues se va a la portada con una carga entera (la app la manda a entrar). Si la caida fue antes de que
// el puente existiera, no hay `logout` que llamar y el boton va igual a la portada.
//
// LOS TEXTOS no dependen de i18next (la caida puede ser antes de que carguen los locales): viven en un objeto propio
// por idioma, y ese idioma es el de i18next si ya arranco, si no el del navegador. Los mismos textos estan en
// `common.json` (`red.titulo`, `red.reintentar`, `red.inicio`; "Cerrar sesion" es el par de la casa,
// `nav.logout`), y `RedDeArranque.pt72c.test.js` fija que coinciden letra por letra.
//
// EL AVISO AL SERVIDOR (`POST /api/client-error`, `backend/routes/client_error_routes.py`) sale en
// `componentDidCatch`, que corre en la fase de commit: antes de que el navegador pinte la pantalla. UNA vez por
// caida, sin esperar respuesta y sin poder tumbar nada. En la web, `navigator.sendBeacon` con un `Blob`
// `application/json` (mismo origen: la cookie de la sesion viaja sola y el aviso sale aunque la pagina se recargue
// enseguida); si no existe o no lo puede encolar, `fetch` con `keepalive`. En la app, `fetch` con `keepalive` y el
// Bearer de la sesion: `sendBeacon` no puede mandar esa cabecera y la cookie no existe ahi. El cuerpo: `mensaje` y
// `pila` (recortados a 2,000), `ruta` (solo el camino), `app`, `version` (el hash del paquete principal, que
// identifica el despliegue de la web y el paquete de la app) y `lang`. Nada mas.
//
// tutor-3 (D, P14): LA CAIDA POR PIEZAS VIEJAS TRAS UN DESPLIEGUE. Quien tenia la pagina abierta desde ANTES de un
// despliegue pide, al cambiar de pantalla, una pieza de la version vieja que ya no existe en Cloudflare
// (`ChunkLoadError: Loading chunk 271 failed`). Eso no es un error de la app: la app se RECARGA SOLA UNA vez
// (`NAVEGACION.recargar()`), sin pintar la pantalla roja (no pinta nada mientras tanto), y el aviso sale con
// `motivo: 'chunk'` (el servidor lo apunta como `CLIENT_CHUNK`, "La app se actualizo sola tras un despliegue"). Para
// no entrar en bucle, la marca `sb_red_recarga` de `sessionStorage` guarda la version (el hash del paquete) que ya se
// recargo: si la marca de ESTA version ya esta (la recarga no arreglo nada), la pantalla de siempre y el aviso sin
// `motivo`, como una caida de verdad. Una version nueva tiene otra marca y permite su recarga. Lo demas, igual.
//
// remate de camara-pills (5.1, firma #723): LA SEGUNDA CAIDA DE PIEZAS DE LA MISMA VERSION NAVEGA CON UNA DIRECCION
// NUEVA. Un navegador que ejecuta el paquete viejo desde su cache recibe ese mismo paquete al recargar, y la recarga
// de arriba no lo salva. Si la marca de esta version ya esta y la segunda (`sb_red_recarga2`, con la misma version)
// no, la red pone la segunda, avisa con `motivo: 'chunk'` e `intento: 2` y hace `location.replace` al camino y la
// consulta de hoy con `v=<ahora>` (sin fragmento): una direccion distinta hace que el navegador y cualquier
// intermediario bajen la version actual. A la TERCERA caida de la misma version, la pantalla de siempre. El
// enrutador ignora la consulta; nadie mas lee `v`.
//
// remate de camara-pills (5.2): el aviso lleva tambien `navegador` (el agente de usuario, tope 200; ya viaja en cada
// peticion) y `sin_red` (`navigator.onLine === false`).

export const VENTANA_DE_LA_MISMA_CAIDA_MS = 30000;
export const LLAVE_DE_LAS_CAIDAS = 'sb_red_caidas';
export const TOPE_DEL_TEXTO = 2000;
export const FONDO_DE_LA_RED = '#111111';
export const NARANJA_DE_LA_CASA = '#FF6B00';
/** tutor-3 (D): la marca de la recarga por piezas viejas (su valor: la version que ya se recargo). */
export const LLAVE_DE_LA_RECARGA = 'sb_red_recarga';
export const MOTIVO_DE_PIEZAS = 'chunk';
/** remate de camara-pills (5.1): la segunda marca (su valor: la version que ya navego con una direccion nueva). */
export const LLAVE_DEL_SEGUNDO_INTENTO = 'sb_red_recarga2';
/** remate de camara-pills (5.2): el tope del agente de usuario en el aviso. */
export const TOPE_DEL_NAVEGADOR = 200;

const PIEZA_QUE_NO_CARGO = [
  /Loading chunk [\w.-]+ failed/i,
  /Loading CSS chunk [\w.-]+ failed/i,
  /Failed to fetch dynamically imported module/i,
];

/** tutor-3 (D): la caida es de una pieza (chunk) que no cargo: la version vieja tras un despliegue. */
export function esCaidaDePiezas(error) {
  try {
    if (!error) return false;
    if (error.name === 'ChunkLoadError') return true;
    const mensaje = typeof error.message === 'string' ? error.message : String(error);
    return PIEZA_QUE_NO_CARGO.some((re) => re.test(mensaje));
  } catch {
    return false;
  }
}

function marcaDeEstaVersion() {
  return versionDelPaquete() || 'sin-version';
}

/** remate de camara-pills (5.1): que toca con esta caida. 'recargar' (la primera caida de piezas de esta version),
 * 'navegar' (la segunda: una direccion nueva) o null (la tercera, una caida que no es de piezas o sin
 * `sessionStorage`: la pantalla de siempre). */
export function queTocaConLaPieza(error) {
  if (!esCaidaDePiezas(error)) return null;
  try {
    const version = marcaDeEstaVersion();
    if (window.sessionStorage.getItem(LLAVE_DE_LA_RECARGA) !== version) return 'recargar';
    if (window.sessionStorage.getItem(LLAVE_DEL_SEGUNDO_INTENTO) !== version) return 'navegar';
    return null;
  } catch {
    return null;
  }
}

/** True si esta caida es de piezas y esta version todavia no se recargo sola. */
export function tocaRecargar(error) {
  return queTocaConLaPieza(error) === 'recargar';
}

/** remate de camara-pills (5.1): el camino y la consulta de hoy con `v=<ahora>`, sin fragmento. */
export function direccionNueva(ahora = Date.now()) {
  let camino = '/';
  let consulta = '';
  try {
    camino = window.location.pathname || '/';
    consulta = window.location.search || '';
  } catch { /* nada */ }
  return `${camino}${consulta}${consulta ? '&' : '?'}v=${ahora}`;
}

/** Los textos (Anexo D.1), por idioma. Mismas letras que `common.json`. */
export const TEXTOS_DE_LA_RED = {
  es: { titulo: 'Algo sali\xf3 mal.', reintentar: 'Reintentar', inicio: 'Ir al inicio', salir: 'Cerrar sesi\xf3n' },
  en: { titulo: 'Something went wrong.', reintentar: 'Retry', inicio: 'Go to the start', salir: 'Log out' },
};
/** Donde vive cada texto en `common.json`. */
export const LLAVES_DE_LA_RED = { titulo: 'red.titulo', reintentar: 'red.reintentar', inicio: 'red.inicio',
  salir: 'nav.logout' };

/** Las tres salidas, en un objeto para que las pruebas las cambien (jsdom no deja espiar `location`). */
export const NAVEGACION = {
  recargar() { window.location.reload(); },
  ir(destino) { window.location.href = destino; },
  // remate de camara-pills (5.1): la segunda caida de piezas, sin dejar la direccion vieja en el historial
  reemplazar(destino) { window.location.replace(destino); },
};

let salidaRegistrada = null;
/** El `logout` de la casa que la red llama en "Cerrar sesion" (lo deja `PuenteDeSalida`). */
export function registrarSalida(fn) {
  salidaRegistrada = typeof fn === 'function' ? fn : null;
}

/** Vive DENTRO de `AuthProvider` y no pinta nada: le deja a la red el `logout` de la casa. */
export function PuenteDeSalida() {
  // perezoso a proposito: la red no carga el proveedor de sesion al importarse
  const { logout } = require('../contexts/AuthContext').useAuth();
  useEffect(() => { registrarSalida(logout); });
  return null;
}

/** 'es' o 'en': el de i18next si ya arranco; si no, el del navegador. */
export function idiomaDeLaRed() {
  let lang = '';
  try {
    const i18n = getI18n();
    if (i18n && i18n.isInitialized) lang = i18n.resolvedLanguage || i18n.language || '';
  } catch {
    lang = '';
  }
  if (!lang) {
    try { lang = (typeof navigator !== 'undefined' && navigator.language) || ''; } catch { lang = ''; }
  }
  return String(lang).toLowerCase().startsWith('es') ? 'es' : 'en';
}

/** Anota esta caida y devuelve cuantas veces seguidas ha caido la MISMA (1, 2 o 3) en la ventana de 30 s. */
export function anotarCaida(mensaje, ahora = Date.now()) {
  let previa = null;
  try { previa = JSON.parse(window.sessionStorage.getItem(LLAVE_DE_LAS_CAIDAS) || 'null'); } catch { previa = null; }
  const misma = !!previa && previa.mensaje === mensaje && typeof previa.en === 'number'
    && ahora - previa.en >= 0 && ahora - previa.en < VENTANA_DE_LA_MISMA_CAIDA_MS;
  const veces = misma ? Math.min((Number(previa.veces) || 1) + 1, 3) : 1;
  try {
    window.sessionStorage.setItem(LLAVE_DE_LAS_CAIDAS, JSON.stringify({ mensaje, veces, en: ahora }));
  } catch { /* sin sessionStorage, siempre la primera */ }
  return veces;
}

/** El hash del paquete principal (`/static/js/main.<hash>.js`), o vacio. */
export function versionDelPaquete() {
  try {
    const scripts = Array.from(document.getElementsByTagName('script'));
    for (const s of scripts) {
      const m = /\/static\/js\/main\.([0-9a-f]+)\.js/.exec(s.getAttribute('src') || '');
      if (m) return m[1];
    }
  } catch { /* nada */ }
  return '';
}

function mensajeDe(error) {
  try {
    if (error && typeof error.message === 'string') return error.message;
    return String(error);
  } catch {
    return '';
  }
}

/** El cuerpo del aviso: los ocho datos y nada mas (remate de camara-pills: `navegador` y `sin_red`). */
export function cuerpoDelAviso(error, info) {
  let pila = '';
  try {
    pila = (error && typeof error.stack === 'string' && error.stack)
      || (info && typeof info.componentStack === 'string' && info.componentStack) || '';
  } catch { pila = ''; }
  let ruta = '';
  try { ruta = window.location.pathname || ''; } catch { ruta = ''; }
  let navegador = '';
  try {
    navegador = String((typeof navigator !== 'undefined' && navigator.userAgent) || '').slice(0, TOPE_DEL_NAVEGADOR);
  } catch { navegador = ''; }
  let sinRed = false;
  try { sinRed = typeof navigator !== 'undefined' && navigator.onLine === false; } catch { sinRed = false; }
  return {
    mensaje: mensajeDe(error).slice(0, TOPE_DEL_TEXTO),
    pila: pila.slice(0, TOPE_DEL_TEXTO),
    ruta,
    app: !!IS_APP_BUILD,
    version: versionDelPaquete(),
    lang: idiomaDeLaRed(),
    navegador,
    sin_red: sinRed,
  };
}

function direccionDelAviso() {
  try {
    // perezoso a proposito: si el modulo de la red de la casa no cargo, no se avisa (la pantalla sale igual)
    return `${require('../lib/api').API_BASE}/api/client-error`;
  } catch {
    return '';
  }
}

function porFetch(url, json, cabeceras, credenciales) {
  try {
    if (typeof fetch !== 'function') return;
    const p = fetch(url, { method: 'POST', keepalive: true, credentials: credenciales,
      headers: { 'Content-Type': 'application/json', ...cabeceras }, body: json });
    if (p && typeof p.catch === 'function') p.catch(() => {});
  } catch { /* nada */ }
}

/** Manda el aviso sin esperar respuesta. Nunca truena. */
export function avisarAlServidor(cuerpo) {
  try {
    const url = direccionDelAviso();
    if (!url) return;
    const json = JSON.stringify(cuerpo);
    if (IS_APP_BUILD) {
      let tokens;
      try {
        tokens = require('../lib/tokenStore').getTokens();
      } catch {
        tokens = null;
      }
      Promise.resolve(tokens)
        .catch(() => null)
        .then((t) => {
          const cabeceras = t && t.access_token ? { Authorization: `${t.token_type || 'Bearer'} ${t.access_token}` } : {};
          porFetch(url, json, cabeceras, 'omit');
        })
        .catch(() => {});
      return;
    }
    if (typeof navigator !== 'undefined' && typeof navigator.sendBeacon === 'function') {
      try {
        if (navigator.sendBeacon(url, new Blob([json], { type: 'application/json' }))) return;
      } catch { /* cae a fetch */ }
    }
    porFetch(url, json, {}, 'include');
  } catch { /* el aviso jamas tumba la pantalla */ }
}

const ACCION = { 1: 'reintentar', 2: 'inicio', 3: 'salir' };

async function cerrarSesion() {
  const salir = salidaRegistrada;
  if (salir) {
    try {
      const r = await salir();
      if (r && r.cancelled) return;
    } catch { /* el logout de la casa ya no truena; si lo hiciera, igual se sale */ }
  }
  NAVEGACION.ir('/');
}

function alTocar(accion) {
  if (accion === 'inicio') NAVEGACION.ir('/dashboard');
  else if (accion === 'salir') cerrarSesion();
  else NAVEGACION.recargar();
}

/** La pantalla de la red. */
export function PantallaDeLaRed({ veces = 1 }) {
  const textos = TEXTOS_DE_LA_RED[idiomaDeLaRed()];
  const accion = ACCION[veces] || 'reintentar';
  return (
    <div
      role="alert"
      data-testid="red-de-arranque"
      data-accion={accion}
      style={{
        position: 'fixed', inset: 0, zIndex: 100, display: 'flex', flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', gap: 24, padding: '0 32px', textAlign: 'center', backgroundColor: FONDO_DE_LA_RED,
      }}
    >
      <img src={logo} alt="" width={64} height={64} style={{ width: 64, height: 64 }} data-testid="red-logo" />
      <p data-testid="red-titulo" style={{ margin: 0, color: '#ffffff', fontSize: 18, fontWeight: 600, lineHeight: 1.4 }}>
        {textos.titulo}
      </p>
      <button
        type="button"
        data-testid="red-boton"
        onClick={() => alTocar(accion)}
        style={{
          minHeight: 44, padding: '0 20px', border: 0, borderRadius: 12, backgroundColor: NARANJA_DE_LA_CASA,
          color: '#ffffff', fontSize: 14, fontWeight: 500, cursor: 'pointer',
        }}
      >
        {textos[accion]}
      </button>
    </div>
  );
}

export default class RedDeArranque extends React.Component {
  constructor(props) {
    super(props);
    this.state = { caida: false, veces: 1, recargando: false, como: null };
  }

  static getDerivedStateFromError(error) {
    const como = queTocaConLaPieza(error);
    return { caida: true, recargando: como !== null, como };
  }

  componentDidCatch(error, info) {
    if (this.state.recargando && this.state.como === 'navegar') {
      // remate de camara-pills (5.1): la segunda caida de piezas de esta version. La segunda marca, el aviso con su
      // intento y una direccion nueva; tampoco se pinta la pantalla.
      try { window.sessionStorage.setItem(LLAVE_DEL_SEGUNDO_INTENTO, marcaDeEstaVersion()); } catch { /* nada */ }
      avisarAlServidor({ ...cuerpoDelAviso(error, info), motivo: MOTIVO_DE_PIEZAS, intento: 2 });
      NAVEGACION.reemplazar(direccionNueva());
      return;
    }
    if (this.state.recargando) {
      // tutor-3 (D): la pieza vieja. La marca, el aviso con su motivo y UNA recarga; no se pinta la pantalla.
      try { window.sessionStorage.setItem(LLAVE_DE_LA_RECARGA, marcaDeEstaVersion()); } catch { /* nada */ }
      avisarAlServidor({ ...cuerpoDelAviso(error, info), motivo: MOTIVO_DE_PIEZAS });
      NAVEGACION.recargar();
      return;
    }
    // fase de commit: antes de que el navegador pinte. Primero el aviso, luego la cuenta de la misma caida.
    avisarAlServidor(cuerpoDelAviso(error, info));
    const veces = anotarCaida(mensajeDe(error).slice(0, TOPE_DEL_TEXTO));
    if (veces !== this.state.veces) this.setState({ veces });
  }

  render() {
    if (this.state.caida && this.state.recargando) return null;
    if (this.state.caida) return <PantallaDeLaRed veces={this.state.veces} />;
    return this.props.children;
  }
}
